import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { useDropzone } from "react-dropzone";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";

const WorksCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [url, setUrl] = useState("");
	const [description, setDescription] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [files, setFiles] = useState([]);

	const [filesTypography, setFilesTypography] = useState([]);

	const [imageArray, setImageArray] = useState([]);

	const [typographyImageArray, setTypographyImageArray] = useState([]);

	const [videoUrl, setVideoUrl] = useState("");

	const [infoTitle, setInfoTitle] = useState("");
	const [infoText, setInfoText] = useState("");

	/// name - date -category
	const [customerName, setCustomerName] = useState("");
	const [workDate, setWorkDate] = useState("");
	const [workCategory, setWorkCategory] = useState("");

	const [informations, setInformations] = useState([]);
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(0);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة عمل جديد",
				breadcrumb: "الأعمال",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/type_categories/our_works`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCategories(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const { getRootProps, getInputProps } = useDropzone({
		accept: "image/*",
		onDrop: acceptedFiles => {
			setFiles(
				acceptedFiles.map(file =>
					Object.assign(file, {
						preview: URL.createObjectURL(file),
					})
				)
			);
		},
	});

	const { getRootProps: getRootPropsTypo, getInputProps: getInputPropsTypo } =
		useDropzone({
			accept: "image/*",
			onDrop: acceptedFiles => {
				setFilesTypography(
					acceptedFiles.map(file =>
						Object.assign(file, {
							preview: URL.createObjectURL(file),
						})
					)
				);
			},
		});

	const thumbs = files.map(file => (
		<div className="thumb" key={file.name}>
			<div className="thumbInner">
				<img src={file.preview} className="img" alt="" />
			</div>
		</div>
	));

	const thumbsTyphography = filesTypography.map(file => (
		<div className="thumb" key={file.name}>
			<div className="thumbInner">
				<img src={file.preview} className="img" alt="" />
			</div>
		</div>
	));

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);
	useEffect(
		() => () => {
			filesTypography.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[filesTypography]
	);

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (infoTitle === "" || infoText === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { title: infoTitle, value: infoText };
		informations.push(data);
		setInformations(informations);
		setInfoTitle("");
		setInfoText("");
	};

	const handleDeleteInfo = (event, information) => {
		event.preventDefault();
		const arr = informations.filter(function (item) {
			return item.title !== information.title;
		});
		setInformations(arr);
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedCategory === 0) {
			toast.error("برجاء اختيار التصنيف اولا!");
			return;
		}
		const picture = document.querySelector("#picture");
		if (picture.files[0]) {
			setLoading(true);
			const data = new FormData();
			data.append("file", picture.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title: title,
						url: url,
						descriptio: description,
						main_image: response.data.data.name,
						inforomation: informations,
						slider: imageArray,
						typographyImageArray,
						pageTitle: pageTitle,
						pageDescrition: pageDescrition,
						pageKeyWords: pageKeyWords,
						pageUrl: pageUrl,
						customerName,
						workDate,
						workCategory,
						videoUrl,
					};
					axios
						.post(
							`${process.env.REACT_APP_API_URL}/posts`,
							{
								category_id: selectedCategory,
								admin_id: auth.data.id,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							history.push("/works/index");
							toast.success("تم اضافة العمل بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	const handleImageUpload = e => {
		e.preventDefault();
		for (let i = 0; i < files.length; i++) {
			const formData = new FormData();
			formData.append(`file`, files[i]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function (responseImage) {
					imageArray.push(responseImage.data.data.name);
					setImageArray(imageArray);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
		toast.success("تم رفع الصور بنجاح!");
	};

	const handleTypographyImageUpload = e => {
		e.preventDefault();
		for (let i = 0; i < filesTypography.length; i++) {
			const formData = new FormData();
			formData.append(`file`, filesTypography[i]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function (responseImage) {
					typographyImageArray.push(responseImage.data.data.name);
					setTypographyImageArray(typographyImageArray);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
		toast.success("تم رفع الصور بنجاح!");
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">التصنيف</label>
									<select
										id="category"
										onChange={e => setSelectedCategory(e.target.value)}
									>
										<option value="0">اختر التصنيف</option>
										{categories.map(category => (
											<option value={category.id} key={category.id}>
												{category.title}
											</option>
										))}
									</select>
								</div>
								<div className="row">
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="url">رابط المعاينة</label>
											<input
												type="text"
												id="url"
												onChange={e => setUrl(e.target.value)}
											/>
										</div>
									</div>
								</div>
								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="videoUrl">رابط الفيديو</label>
									<input
										type="text"
										id="videoUrl"
										value={videoUrl}
										onChange={e => setVideoUrl(e.target.value)}
									/>
								</div>

								<label className="my-4">صور العمل</label>
								<div className="dropzoneContainer">
									<div {...getRootProps({ className: "dropzone" })}>
										<input {...getInputProps()} />
										<p>اضغط هنا لرفع الصور</p>
									</div>
									<aside className="thumbsContainer">{thumbs}</aside>
									<button onClick={handleImageUpload} className="bt bt-success">
										رفع الصور
									</button>
								</div>
								<br />
								<label className="my-4">صور التايبوجرافي</label>
								<div className="dropzoneContainer">
									<div {...getRootPropsTypo({ className: "dropzone" })}>
										<input {...getInputPropsTypo()} />
										<p>اضغط هنا لرفع الصور</p>
									</div>
									<aside className="thumbsContainer">{thumbsTyphography}</aside>
									<button
										onClick={handleTypographyImageUpload}
										className="bt bt-success"
									>
										رفع الصور
									</button>
								</div>
								<br />
								<hr />
								<br />
								<div className="form-item">
									<label htmlFor="question">عنوان المعلومة</label>
									<input
										type="text"
										id="question"
										value={infoTitle}
										onChange={e => setInfoTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="answer">نص المعلومة</label>
									<textarea
										id="answer"
										cols="30"
										rows="2"
										value={infoText}
										onChange={e => setInfoText(e.target.value)}
									></textarea>
								</div>
								<div className="form-item"></div>
								<button className="bt bt-success" onClick={pushToInformation}>
									اضافة المعلومة
								</button>
								<div className="form-item my-4">
									<label htmlFor="customer-name"> اسم العميل</label>
									<input
										type="text"
										id="customer-name"
										value={customerName}
										onChange={e => setCustomerName(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="work-date"> تاريخ العمل </label>

									<input
										type="date"
										id="work-date"
										value={workDate}
										onChange={e => setWorkDate(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="work-category"> تصنيف العمل</label>
									<input
										type="text"
										id="work-category"
										value={workCategory}
										onChange={e => setWorkCategory(e.target.value)}
									/>
								</div>

								<div className="form-item" style={{ marginTop: "40px" }}>
									<ul className="list-unstyled pointList">
										{informations.map(information => (
											<li key={information.title}>
												<button onClick={e => handleDeleteInfo(e, information)}>
													<i className="fas fa-trash"></i>
												</button>
												<span>{information.title}:</span>
												{information.value}
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default WorksCreate;
